import { type FC } from "react";

import { type TypeInfo } from "@moment/api-collab/differential/schema/index";

const ColumnTypeExplanation: FC<{
	columnType: TypeInfo["enrichedType"];
}> = ({ columnType }) => {
	switch (columnType) {
		case "Text":
			return (
				<div>
					<code className="font-semibold text-secondary">{columnType}</code> columns
					allows users to input text, optionally pre-filled with a default value.
				</div>
			);
		case "Reaction":
			return (
				<div>
					<code className="font-semibold text-secondary">{columnType}</code> columns
					provide users a button they can click to vote on topics, react to proposals, and
					so on.
				</div>
			);
		case "Select":
			return (
				<div>
					<code className="font-semibold text-secondary">{columnType}</code> columns
					display a dropdown list of options to seelect from, optionally pre-filled with a
					default value.
				</div>
			);
		case "Person":
			return (
				<div>
					<code className="font-semibold text-secondary">{columnType}</code> columns
					display a dropdown list of users, in the workspace, which can be used to assign
					tasks, designate responsibilities, delegate a point-of-contact, and so on..
				</div>
			);
		default: {
			const _exhaustiveCheck: never = columnType;
			throw new Error(`Unknown column type: ${_exhaustiveCheck}`);
		}
	}
};

export default ColumnTypeExplanation;
